import cx from 'classnames';
import React from 'react';

import styles from './styles.css';
import { useIsSmall } from '../../../Components/Context/Hooks/mediaQueries';
import Box, { BoxProps } from '../../../Components/UI/Box';

const Header: React.FC<BoxProps> = ({ children, ...rest }) => {
  const isSmall = useIsSmall();

  return (
    <Box
      element="header"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      paddingHorizontal={4}
      className={cx(styles['header'], { [styles['header--mobile']]: isSmall })}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Header;
